import { render, staticRenderFns } from "./PSlider.vue?vue&type=template&id=4b48421a&"
import script from "./PSlider.vue?vue&type=script&lang=ts&"
export * from "./PSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports